export default "__VITE_ASSET__CvwaY13X__"